export default __webpack_public_path__ + "static/media/like.abb4ca09.svg";